export const mobileNavTranslations = {
  fr: {
    home: "Accueil",
    chat: "Chat",
    cards: "Cartes",
    achievements: "Succès",
    profile: "Profil",
  },
  en: {
    home: "Home",
    chat: "Chat",
    cards: "Cards",
    achievements: "Achievements",
    profile: "Profile",
  },
  es: {
    home: "Inicio",
    chat: "Chat",
    cards: "Tarjetas",
    achievements: "Logros",
    profile: "Perfil",
  },
};
